import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DatabricksDeltashareForNro = lazy(() =>
  import("@scenes/DatasharesIntegration/DatabricksDeltashareForNro").then((module) => ({
    default: module.DatabricksDeltashareForNro,
  }))
);

export const databricksDeltashareNRO: NavigationRoutingObject = {
  Component: DatabricksDeltashareForNro,
  // eslint-disable-next-line local-eslint-rules/enforce-nro-component-feature-flipper-use
  componentFeatureFlippers: [
    "datashares_integrations",
    "datashares_integration_nro_component",
    "delta_sharing_beta",
  ],
  section: "partner-integrations",
  heading: (t: I18nT<"dashboard-navigation">) => t("datashares-sidebar-pill-menu-option", "Data Sharing"),
  icon: "nav-system-data-sharing",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("datashares_integrations") && featureOn("delta_sharing_beta");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/datashares_integrations/:appGroupId",
};
